import React, { Component, PropTypes } from 'react';
import t from 'tcomb-form';
import CityAutosuggestFactory from '../components/CityAutosuggest';
import { flattenDeep } from 'lodash/array';
import { union } from 'lodash/array';
import isLoggedIn from '../utils/index';
import { push, replace } from 'react-router-redux';
import { connect } from 'react-redux';
import { uniq, pull, remove } from 'lodash/array';




let categoryRootsObjArray = [];
let savedRootCategories = [];
let savedRootCategoriesClicked = [];


class UserInterestsStep1 extends Component {
  constructor(props) {
    super(props);

  }

  state = {
		//categoryRootObjs: categoryRootsObjArray
    hasStateChanged: false
  };


  componentWillReceiveProps(nextProps) {

  }

  componentWillMount() {

  }


  componentDidMount() {
    window.scrollTo(0,0);

  }


  categoryExists = (objArray, rootid) => {
    return objArray.some(function(el) {
      return el.rootid === rootid;
    });
  }


  // Handle root category Obj click
  handleSelectCategoryObj = catRootId => {
    let tmpNewCategoryObj = [];
    let tmpSavedCategoryObjs = this.props.categoryRootObjs;
    // Test if category root is in categoryRootObjs on parent
    if (this.categoryExists(this.props.categoryRootObjs, catRootId)) {
      let result = this.props.categoryRootObjs.filter((obj) => {
        return obj.rootid !== catRootId;
      });
      this.props.setParentCategoryState(result);

    } else {
      tmpNewCategoryObj = {rootid: catRootId, childId: []};
      tmpSavedCategoryObjs.push(tmpNewCategoryObj);

      // Set state on parent so page 2 has access to category roots
      this.props.setParentCategoryState(tmpSavedCategoryObjs);
    }
    this.setState({hasStateChanged: true});
  }

  goToStep2 = categoryRootIds => {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(categoryRootIds);
    }
  }

  render() {
    if (!this.props.myInterests.isLoaded) {
      return <span />;
    }
    const { categories } = this.props.baseState;
    const { user } = this.props.auth;

    let imgWidth = '';
    let imgHeight = '';
    let imgPath = '';
    if (!this.props.browser.greaterThan.tablet) { // tablet
      imgWidth = this.props.browser.width - 20;
      imgHeight = imgWidth / 2;
    }

    if (this.props.browser.lessThan.desktop) {
      imgPath = '/images/categories/mobile/';
    } else { // point to desktop
      imgPath = '/images/categories/desktop/';
    }

    let categoryRootBoxes = [];
    let categoryName = '';
    let categoryImgName = '';
    let checkState = 'hide';

    categoryRootBoxes = categories.map((category, index) => {
      // parse category name for image files
      categoryName = category.name;
      categoryImgName = categoryName.toLowerCase();
      categoryImgName = categoryImgName.replace(/\s/g, "_");
      categoryImgName = categoryImgName.replace("'", "");

			if (this.categoryExists(this.props.categoryRootObjs, category.id)) {
				checkState = 'checkmark-show';
			} else {
				checkState = 'checkmark-hide';
			}

      // Filter out Buy from Women categories for interests
      if (category.slug == 'buy-from-women' || category.slug == 'buy-from-women-products' || category.slug == 'buy-from-women-services') {
        return;

      }

      return <div onClick={this.handleSelectCategoryObj.bind(null, category.id)} className={`userInfo-categoryBoxWrapper`}>
          <div className={"userInfo-categoryBoxCheckmark " + checkState} style={{backgroundImage: 'url(' + imgPath + category.slug + '.jpg)', backgroundSize: 'cover'}}>

            <div className="userInfo-categoryBoxName">
              {category.name}
            </div>

            <img src={`${imgPath}checkmark.png`} />

          </div>


        </div>


      });


    return (
      <div className="userInfo-categoryBoxes-wrapper">
          {categoryRootBoxes}
      </div>
    );
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    replace
  }
)(UserInterestsStep1);



// WEBPACK FOOTER //
// ./src/components/UserInterestsStep1.jsx